// extracted by mini-css-extract-plugin
module.exports = {"videoWrapper":"YoutubePlayerWrapper-module--videoWrapper--2ni01","video":"YoutubePlayerWrapper-module--video--1Z5st","iframe":"YoutubePlayerWrapper-module--iframe--pMq0v"};